const PasswordRex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*?[~!@#$^*()_+])([a-zA-Z\d~!@#$^*()_+])+$/;
const ProductName = 'sensexperience';
const CompanyName = 'sensetime';
export const validatePassword = (value, accountName) => {
    if (!value || value.length < 8 || value.length > 128) {
        return 'length';
    }
    if (!PasswordRex.test(value)) {
        return 'charType';
    }
    if (value.toLowerCase().includes(ProductName) || value.toLowerCase().includes(CompanyName)) {
        return 'tooSimple';
    }
    if (hasContinuance(value)) {
        return 'tooSimple';
    }
    if (accountName && value.includes(accountName)) {
        return 'tooSimple';
    }
};
const CheckWidth = 3;
const hasContinuance = (str) => {
    for (let i = 0; i <= str.length - CheckWidth; i++) {
        if (checkContinuance(str.substr(i, CheckWidth))) {
            return true;
        }
    }
    return false;
};
const CharCode0 = '0'.charCodeAt(0);
const CharCode9 = '9'.charCodeAt(0);
const CharCode_a = 'a'.charCodeAt(0);
const CharCode_z = 'z'.charCodeAt(0);
const CharCode_A = 'A'.charCodeAt(0);
const CharCode_Z = 'Z'.charCodeAt(0);
const checkContinuance = (word) => {
    let pre = word.charCodeAt(0);
    for (let i = 1; i < word.length; i++) {
        const currentCode = word.charCodeAt(i);
        const isAlphanumeric = (currentCode >= CharCode0 && currentCode <= CharCode9) ||
            (currentCode >= CharCode_a && currentCode <= CharCode_z) ||
            (currentCode >= CharCode_A && currentCode <= CharCode_Z);
        if (!isAlphanumeric) {
            return false;
        }
        if ((currentCode - pre) !== 1) {
            return false;
        }
        pre = currentCode;
    }
    return true;
};
